import styled from "styled-components";

const LeftPart = styled.div`
  margin-top: 100px;
  width: 50%;
  padding-right: 1.5rem !important;

  @media (max-width: 1199px) {
    margin-top: 50px;
  }

  @media (max-width: 575px) {
    padding-right: 0 !important;
    margin-top: 25px;
    width:100%;
  }
`;

export default LeftPart;
